module.exports = __webpack_public_path__ + "static/media/team-member-3.3a768c4c.jpeg";